import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import _isFunction from 'lodash/isFunction';
import { FEEDBACK_ERROR, FEEDBACK_SUCCESS } from './CatalogItemShareButton.constants';
import { GoogleAnalytics } from '../../../../services/analytics';
import { copyToClipboard } from '../../../../utils/clipboard';
import { EventPropType } from '../../../analytics/types';
import ShareButton from '../../../engagement/components/ShareButton';
import useEventPropagation from '../../../foundation/hooks/use-event-propagation';
import './CatalogItemShareButton.css';
var defaultProps = {
  event: {}
};
function CatalogItemShareButton(_ref) {
  var url = _ref.url,
    event = _ref.event;
  var _useEventPropagation = useEventPropagation(),
    preventPropagation = _useEventPropagation.preventPropagation;
  function onShare(_x) {
    return _onShare.apply(this, arguments);
  }
  function _onShare() {
    _onShare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var urlToCopy;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            preventPropagation(e, {
              preventDefault: true
            });
            GoogleAnalytics.triggerEvent(event);
            urlToCopy = _isFunction(url) ? url() : url;
            _context.next = 5;
            return copyToClipboard(urlToCopy);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onShare.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(ShareButton, {
    onShare: onShare,
    messages: {
      success: FEEDBACK_SUCCESS,
      failure: FEEDBACK_ERROR
    }
  });
}
CatalogItemShareButton.defaultProps = defaultProps;
export default CatalogItemShareButton;